import { CplRequestSummaryItem } from "./cpl-request-summary-item.model";
import { CplRequestItem } from "./cpl-request-item.model";
import { EdlTemplateTypeDTO } from "@edl-development/edl-common";

export class CplRequestBasicData {
    RequestID: string;
    PortalID: number;
    Title: string;
    EdlTemplateTypes: EdlTemplateTypeDTO[];

    constructor(RequestID: string, PortalID: number, Title: string, EdlTemplateTypes: EdlTemplateTypeDTO[] = []) {
        this.RequestID = RequestID;
        this.PortalID = PortalID;
        this.Title = Title;
        this.EdlTemplateTypes = EdlTemplateTypes;
    }

    static BasicsFromCplRequestSummaryItem(request: CplRequestSummaryItem) {
        return new CplRequestBasicData(request.RequestID, request.PortalID, request.Title)
    }

    static BasicsFromCplRequestItem(requestItem: CplRequestItem) {
        return new CplRequestBasicData(requestItem.RequestID, requestItem.PortalID, requestItem.Title);
    }
}